import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl, defineMessages } from 'react-intl';
import * as IDatabase from '../../../types/database';

interface ICreateSectionProps {
    onSave: (name: string, index?: number) => Promise<void>;
    modalId: string;
    title: string;
    sections?: IDatabase.ISection[];
}
interface IState {
    name: string;
    index?: number;
}
class CreateSection extends React.Component<ICreateSectionProps & InjectedIntlProps, IState> {
    state = {
        name: '',
        index: 0
    };

    messages = defineMessages({
        close: {
            id: 'db.create.section.close',
            defaultMessage: 'Close'
        }
    });

    onChange = (event: any) => {
        this.setState({ name: event.target.value });
    };

    onChangeIndex = (event: any) => {
        this.setState({ index: event.target.value });
    };

    onSubmit = async () => {
        const { onSave } = this.props;
        this.setState({ name: '', index: 0 });
        await onSave(this.state.name, this.state.index);
    };

    renderIndex = () => {
        if (this.props.sections) {
            return (
                <div className="formcol">
                    <label><FormattedMessage id="db.create.section.position" defaultMessage="Position" /></label>
                    <select onChange={this.onChange}>
                        {this.props.sections.map((x, i) => <option key={`section-create-index-${i}`} value={i + 1}>{i + 1}</option>)}
                    </select>
                </div>
            )
        }
        return null
    }

    render() {
        const { modalId } = this.props;
        return (
            <div
                id={modalId}
                className="modal fade"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            {this.props.title}
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label={this.props.intl.formatMessage(this.messages.close)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="formContainer">
                                <div className="formrow">
                                    <div className="formcol">
                                        <label><FormattedMessage id="db.create.section.name" defaultMessage="Name" /></label>
                                        <input
                                            type="text"
                                            value={this.state.name}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    {this.renderIndex()}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <FormattedMessage id="db.create.section.add.btn" defaultMessage="Add">
                                {(txt) => (<button onClick={this.onSubmit} className="primary" data-dismiss="modal">{txt}</button>)}
                            </FormattedMessage>
                            <FormattedMessage id="db.create.section.cancel.btn" defaultMessage="Cancel">
                                {(txt) => (<button className="btn btn-link" data-dismiss="modal">{txt}</button>)}
                            </FormattedMessage>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default injectIntl(CreateSection);


// WEBPACK FOOTER //
// ./src/client/database/setup/CreateSection.tsx